import Select from 'react-select';
import React from 'react';

const customStyles = (isOverflow: boolean) => {
  return {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: 'white',
      borderColor: '#002230',
      minHeight: '25px',
      maxHeight: 'unset',
      fontSize: '16px',
      borderRadius: '0px',
      borderStyle: 'none',
      boxShadow: 'none',
      flexWrap: 'wrap',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: '25px',
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      padding: '4px',
      color: '#002230',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      padding: '0px 2px',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '2px',
      maxHeight: '50px',
      overflowY: isOverflow ? 'auto' : 'hidden',
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: '#002230',
      fontSize: '16px',
      height: '28px',
      padding: '2px',
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: 'white',
      color: '#002230',
      marginTop: 0,
      zIndex: 9999,
      borderRadius: 0,
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuList: (provided: any) => ({
      ...provided,
      padding: 0,
      borderRadius: 0,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#f9f5ed' : 'white',
      color: '#002230',
      cursor: 'pointer',
      padding: '5px',
      '&:hover': {
        backgroundColor: '#48af98',
        color: 'white',
      },
      minHeight: '30px',
    }),
    noOptionsMessage: (provided: any) => ({
      ...provided,
      color: '#002230',
      padding: '10px',
      fontSize: '14px',
      borderRadius: 0,
    }),
    multiValue: (provided: any) => ({
      ...provided,
      backgroundColor: '#e8e4df',
      borderRadius: '5px',
      height: '18px',
      margin: '0px',
    }),
    multiValueLabel: (provided: any) => ({
      ...provided,
      color: '#002230',
      fontSize: '11px',
      padding: '2px 6px',
    }),
    multiValueRemove: (provided: any) => ({
      ...provided,
      cursor: 'pointer',
      color: '#002230',
      ':hover': {
        borderRadius: '5px',
        color: 'white',
      },
    }),
  };
};

const ReactSelectFilter = ({
  value,
  isMulti,
  options,
  onChange,
  placeholder = 'Select...',
  isDisabled = false,
  noOptionsMessage,
  menuPortalTarget,
}: {
  value: any;
  isMulti: boolean;
  options: any[];
  onChange: (val: any) => void;
  placeholder?: string;
  isDisabled?: boolean;
  noOptionsMessage?: () => string;
  menuPortalTarget?: HTMLElement | null;
}) => {
  const showSelectAll = isMulti && options.length > 1;
  const selectAllOption = { value: 0, label: 'All' };

  const modifiedOptions = showSelectAll
    ? [selectAllOption, ...options]
    : options;

  const getSelectedOptions = () => {
    if (!isMulti) return modifiedOptions.find((opt) => opt.value === value);
    return modifiedOptions.filter((opt) => value.includes(opt.value));
  };

  const handleChange = (selected: any) => {
    if (isMulti) {
      if (!selected || !Array.isArray(selected)) {
        onChange([]);
        return;
      }

      const hasSelectAll = selected.some((opt) => opt.value === 0);
      let finalValues;
      if (hasSelectAll) {
        // "All" is selected → select all actual options (excluding the "All" one)
        finalValues = options.map((opt) => opt.value);
      } else {
        finalValues = selected.map((opt) => opt.value);
      }

      onChange(finalValues);
    } else {
      onChange(selected.value);
    }
  };

  return (
    <Select
      styles={customStyles(isMulti && Array.isArray(value) && value.length > 3)}
      value={getSelectedOptions()}
      onChange={handleChange}
      options={modifiedOptions}
      isMulti={isMulti}
      classNamePrefix='react-select'
      isSearchable={isMulti}
      placeholder={placeholder}
      isDisabled={isDisabled}
      noOptionsMessage={noOptionsMessage}
      menuPortalTarget={menuPortalTarget}
      menuPosition={menuPortalTarget ? 'fixed' : undefined}
    />
  );
};

export default ReactSelectFilter;
